import { AzureDataExplorerCopySink } from 'app/model/pipeline/copysink/azure-data-explorer.copysink';
import { KustoDatabaseDataset, Metamodel } from 'shell-models-lib';
import { adfModelTypeMap } from 'app/registries/consts/adf-model-type-map-const';

@Metamodel.model({
    name: adfModelTypeMap.kustoDatabase.copySinkType,
    display: [],
    referable: true,
    tags: { datasetModel: Metamodel.modelFor(KustoDatabaseDataset) }
})
export class KustoDatabaseCopySink extends AzureDataExplorerCopySink {}
